import { render, staticRenderFns } from "./DashTopChart.vue?vue&type=template&id=280f077c&scoped=true"
import script from "./DashTopChart.vue?vue&type=script&lang=js"
export * from "./DashTopChart.vue?vue&type=script&lang=js"
import style0 from "./DashTopChart.vue?vue&type=style&index=0&id=280f077c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280f077c",
  null
  
)

export default component.exports